var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavbarLogoMarkDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 53.1957,
    height: 47.4407,
    viewBox: "0 0 53.1957 47.4407",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M46.0123 26.0316L43.6889 23.7152L53.1922 14.2257L53.1957 47.4373H43.0522L19.3439 23.7186L43.0522 0.00344197L53.1922 0L53.1888 8.19534L37.6621 23.7152L45.9779 32.0207L46.0123 26.0316Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M36.984 47.4373L18.6624 47.4338L0 28.7749V18.6555L18.6589 4.61237e-06H36.9805L13.2722 23.7152L36.984 47.4373Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.577 47.4407L0 47.4373V34.8637L12.577 47.4407Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M12.5598 4.61237e-06L0 12.5632V4.61237e-06H12.5598Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavbarLogoMarkDark);
export default __webpack_public_path__ + "static/media/navbar-logo-mark-dark.43227750e2d1afcb5accd9a4076b634e.svg";
export { ForwardRef as ReactComponent };